import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "@store/store";
import { MutationPayload, PatchPayload } from "@models/ninox.model";

/** Base API route for data endpoints */
const API_ROUTE = "/api/data";

/**
 * API service for interacting with the Ninox backend
 */
export const ninoxApiService = createApi({
  reducerPath: "ninoxApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROUTE,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.token || localStorage.getItem("auth_token");

      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    /** Creates new data entry */
    postData: builder.mutation<unknown, MutationPayload>({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "POST",
        body: payload,
      }),
    }),
    /** Updates existing data entry */
    putData: builder.mutation<unknown, MutationPayload>({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "PUT",
        body: payload,
      }),
    }),
    /** Partially updates data entry */
    patchData: builder.mutation<unknown, PatchPayload>({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "PATCH",
        body: payload,
      }),
    }),
  }),
});

export const { usePostDataMutation, usePutDataMutation, usePatchDataMutation } =
  ninoxApiService;
